@if (alertCancelarPedido) {
  <div class="body-alert">
    <div class="div-alert">
      <h1 class="titulo-alert ps-4 pt-4 mb-4">Cancelar pedido</h1>
      @if (dadosPedido) {
        <div class="px-4">
          <div class="row">
            <div class="col-6 col-md-3 col-lg-2 mb-4">
              <span class="titulo-api">Número do pedido</span>
              <p class="dado-api">{{dadosPedido.idPedido}}</p>
            </div>
            <div class="col-6 col-md-3 col-lg-2 mb-4">
              <span class="titulo-api">Emissão</span>
              <p class="dado-api">{{dadosPedido.dataEmissao | appDate: 'dd/MM/yyyy'}} {{dadosPedido.dataEmissao | appDate:"HH:mm"}}</p>
            </div>
            <div class="col-6 col-md-3 col-lg-2 mb-4">
              <span class="titulo-api">Data pagamento</span>
              @if (dadosPedido.dataPagamento) {
                <p class="dado-api">{{dadosPedido.dataPagamento | appDate: 'dd/MM/yyyy'}} {{dadosPedido.dataPagamento | appDate:"HH:mm"}}</p>
              }
              @if (!dadosPedido.dataPagamento) {
                <p class="dado-api">Sem data</p>
              }
            </div>
            <div class="col-6 col-md-3 col-lg-2 mb-4">
              <span class="titulo-api">Data Entrega</span>
              <p class="dado-api">{{dadosPedido.dataEntrega | appDate: 'dd/MM/yyyy'}} {{dadosPedido.dataEntrega | appDate:"HH:mm"}}</p>
            </div>
            <div class="col-6 col-md-6 col-lg-4 mb-4">
              <span class="titulo-api">Tipo</span>
              <p class="dado-api">{{dadosPedido.tipoPedido | camelCase}}</p>
            </div>
            <!-- 2ª PARTE -->
            <div class="col-6 col-md-3 col-lg-2 mb-4">
              <span class="titulo-api">Contato</span>
              <p class="dado-api">{{dadosPedido.nomeContato | camelCase}}</p>
            </div>
            <div class="col-6 col-md-3 col-lg-2 mb-4">
              <span class="titulo-api">Sti. Financeiro</span>
              <p class="dado-api">{{dadosPedido.situacaoFinanceiro | camelCase}}</p>
            </div>
            <div class="col-6 col-md-3 col-lg-2 mb-4">
              <span class="titulo-api">Sit. Operacional</span>
              <p class="dado-api">{{dadosPedido.situacaoOperacional}}</p>
            </div>
            <div class="col-6 col-md-6 col-lg-6 mb-4">
              <span class="titulo-api">Ordem dos envelopes/recibos</span>
              <p class="dado-api">{{dadosPedido.ordemEnvelopesRecibos | camelCase}}</p>
            </div>
            <!-- 3ª PARTE -->
            <div class="col-6 col-md-3 col-lg-2 mb-4">
              <span class="titulo-api">Valor Itens</span>
              <p class="dado-api">{{dadosPedido.valorItens}}</p>
            </div>
            <div class="col-6 col-md-3 col-lg-2 mb-4">
              <span class="titulo-api">Valor Taxa</span>
              <p class="dado-api">{{dadosPedido.valorTaxas}}</p>
            </div>
            <div class="col-6 col-md-3 col-lg-2 mb-4">
              <span class="titulo-api">Valor Pedido</span>
              <p class="dado-api">{{dadosPedido.valorTotal}}</p>
            </div>
            @if (dadosCancelamento === null) {
              <div class="col-12 mb-4">
                <div class="card-cancelamento">
                  <div>
                    <div class="text-center">
                      <output class="spinner-border c-primary">
                        <span class="visually-hidden">Cancelando pedido ...</span>
                      </output>
                    </div>
                    <p class="legenda-spinner">Cancelando pedido ...</p>
                  </div>
                </div>
              </div>
            }
            @if (dadosCancelamento === false) {
              <div class="col-12 mb-4 text-center">
                <img src="/assets/img/erro.png" alt="representando o erro ao consultar dados da lista de usuários" width="200px">
                <p class="legenda-erro">Ocorreu um erro ao consultar os dados da lista de usuários.</p>
              </div>
            }
            @if (dadosCancelamento === true) {
              <div class="col-12 mb-4 text-center">
                <h3 class="titulo-sem-inconsistencias">Tudo certo! ✓</h3>
                <p class="descricao-sem-inconsistencias">Seu pedido foi cancelado, você será redirecionado de volta para a lista de pedidos.</p>
              </div>
            }
          </div>
        </div>
      }
      @if (clicouConfirmar === false) {
        <div class="footer-alert">
          <p class="subtitulo-alert">Deseja realmente cancelar esse pedido?</p>
          <button class="botao-secundario mt-3 me-3" id="btnConfirmar" (click)="confirmarCancelamento()">CONFIRMAR</button>
          <button class="botao-secundario-outline mt-3" id="btnVoltar" (click)="fecharAlertCancelarPedido()">VOLTAR</button>
        </div>
      }
    </div>
  </div>
}
